var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningSign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warning",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Icons_24_Status_Warning_background",
    "data-name": "Icons/24/Status/Warning background",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_Color",
    "data-name": "Icon Color",
    d: "M19.167,17.47H.832a.833.833,0,0,1-.721-1.25L9.279.385a.867.867,0,0,1,1.442,0L19.888,16.22a.833.833,0,0,1-.721,1.25ZM10,12.525a1.222,1.222,0,1,0,1.223,1.222A1.224,1.224,0,0,0,10,12.525ZM9.017,5.8l.372,5.5h1.222l.394-5.5Z",
    transform: "translate(2 3)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSign);
export default __webpack_public_path__ + "static/media/warning_sign.b686401ee669ee786e521e4561cdd2f2.svg";
export { ForwardRef as ReactComponent };